export default __webpack_public_path__ + "static/media/git.fa4fac61.png";